import React from "react";
import styled from "styled-components";

const AvaterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 60%;
  height: 80%;

  @media only screen and (max-width: 560px) {
    width: 80%;
    height: 100%;
  }
  /* overflow: hidden; */
  border: 1px solid var(--border-color-main);
  border-radius: 50%;

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: -1px;
    top: -1px;
    background: var(--animated-glowing-border);
    background-size: 400%;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    z-index: -1;
    border-radius: 50%;
    background-position: 200% 0;
    animation: animate 10s linear infinite;
  }
  *&::after {
    filter: blur(40px);
  }
  @keyframes animate {
    0% {
      background-position: 0 0;
    }
    50% {
      background-position: 400% 0;
    }
    100% {
      background-position: 0 0;
    }
  }
`;
const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

function Avatar({imageUrl}) {
  return (
    <AvaterContainer>
      <AvatarImage src={imageUrl} />
    </AvaterContainer>
  );
}

export default Avatar;
